import {immerable} from "immer";
import ExtractionArticleElementType from "../enums/extraction-article-element-type";
import ExtractionNodeElement from "../interfaces/extraction-node-element.ts";
import ExtractionOperation from "@/pages/takeoff/layouts/extraction/context/models/enums/extraction-operation.ts";

abstract class ExtractionSheetArticleElementBase implements ExtractionNodeElement {
    [immerable] = true;
    
    id: string;

    parentArticleId: string;
    
    type: ExtractionArticleElementType;

    dataKey: string;

    value = 0;

    unity: string

    operation: ExtractionOperation;
    
    elements : number;
    
    protected constructor(id: string, parentArticleId: string, type: ExtractionArticleElementType, trackedDataType: string, unity: string, operation?: ExtractionOperation) {
        this.id = id;
        this.parentArticleId = parentArticleId;
        this.type = type;
        
        this.dataKey = trackedDataType;
        this.unity = unity;
        this.operation = operation ?? ExtractionOperation.SUM;
        this.elements = 1;
    }
}

export default ExtractionSheetArticleElementBase;